import React from 'react';
import '../../css/components/RoundsTabs.css';

/**
 * Прогрессбар раунда.
 *
 * Показывает две полосы:
 * 1. Прогресс времени раунда (startTime → endTime) — сколько процентов
 *    длительности раунда уже прошло. Для ENDED — 100%, для будущих — 0%.
 * 2. Прогресс загрузки треков (загружено / ожидается участников) —
 *    опционально, используется на вкладке «Отборочный».
 *
 * @component
 * @param {Object} props.round - Данные раунда (startTime, endTime, status)
 * @param {Array} [props.tracks=[]] - Загруженные треки раунда
 * @param {number} [props.participantsCount=0] - Ожидаемое число участников
 * @param {boolean} [props.showTracks=false] - Показывать полосу треков
 */
const RoundProgressBar = ({
  round,
  tracks = [],
  participantsCount = 0,
  showTracks = false
}) => {
  const now = Date.now();
  const start = round?.startTime ? new Date(round.startTime).getTime() : null;
  const end = round?.endTime ? new Date(round.endTime).getTime() : null;

  // Прогресс времени раунда
  let timePercent = null;
  if (start && end && end > start) {
    if (round?.status === 'ENDED' || now >= end) {
      timePercent = 100;
    } else if (now <= start) {
      timePercent = 0;
    } else {
      timePercent = Math.min(100, Math.round(((now - start) / (end - start)) * 100));
    }
  } else if (round?.status === 'ENDED') {
    timePercent = 100;
  }

  // Прогресс загрузки треков
  const uploaded = Array.isArray(tracks) ? tracks.length : 0;
  const expected = participantsCount > 0 ? participantsCount : 0;
  const trackPercent =
    showTracks && expected > 0 ? Math.min(100, Math.round((uploaded / expected) * 100)) : null;

  if (timePercent === null && trackPercent === null) {
    return null;
  }

  return (
    <div className="round-progress">
      {timePercent !== null && (
        <div className="round-progress__row">
          <div className="round-progress__bar" role="progressbar" aria-valuenow={timePercent} aria-valuemin="0" aria-valuemax="100">
            <div
              className={`round-progress__fill round-progress__fill--time ${
                timePercent >= 100 ? 'round-progress__fill--done' : ''
              }`}
              style={{ width: `${timePercent}%` }}
            />
          </div>
          <span className="round-progress__label">
            {timePercent >= 100 ? 'Раунд завершён' : `⏳ ${timePercent}% времени раунда`}
          </span>
        </div>
      )}

      {trackPercent !== null && (
        <div className="round-progress__row">
          <div className="round-progress__bar" role="progressbar" aria-valuenow={trackPercent} aria-valuemin="0" aria-valuemax="100">
            <div
              className={`round-progress__fill round-progress__fill--tracks ${
                trackPercent >= 100 ? 'round-progress__fill--done' : ''
              }`}
              style={{ width: `${trackPercent}%` }}
            />
          </div>
          <span className="round-progress__label">
            🎤 Треки: {uploaded} из {expected}
          </span>
        </div>
      )}
    </div>
  );
};

export default RoundProgressBar;
